import React, { useState } from "react";
import ImageUpload from "src/Components/GlobalComponents/ImageUplaod";
import BoxWrapper from "src/Components/WebsiteComponents/BoxWrapper";
import SimpleInput from "src/Components/SimpleInput";
import GradientBtn from "src/Components/WebsiteComponents/GradientBtn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faArrowDown,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { getShippingAddresses } from "src/helpers/helperFunctions";
import { IAddressData } from "src/types/GlobalInterfaces";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DileveryAddressTitle from "src/Components/GlobalComponents/DileveryAddressTitle";
import httpRequest from "src/helpers/httpRequest";
import { useSelector } from "react-redux";
import { RootState } from "src/Store/store";
import { useNavigate } from "react-router-dom";

function ValidPrescription() {
  const { address } = useSelector((state: RootState) => state.cartSlice);
  const [prescription, setPrescription] = React.useState<File | null>(null);
  const [EmiratesIDFont, setEmiratesIDFront] = React.useState<File | null>(
    null
  );
  const [EmiratesIDBack, setEmiratesIDBack] = React.useState<File | null>(null);
  const [InsuranceIDFront, setInsuranceIDFront] = React.useState<File | null>(
    null
  );
  const [InsuranceIDBack, setInsuranceIDBack] = React.useState<File | null>(
    null
  );
  const [message, setMessage] = React.useState<string>("");
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!prescription && !message) {
      toast.error("Please upload Prescription File");
      return;
    }
    if (!EmiratesIDFont) {
      toast.error("Please upload EmiratesIDFont File");
      return;
    }
    if (!EmiratesIDBack) {
      toast.error("Please upload EmiratesIDBack File");
      return;
    }

    if (typeof address === "string" || !address) {
      toast.error("Please add a delivery address first");
      return;
    }

    if(!message.trim()) {
      toast.error("Message is required");
      return;
    }

    let payload = {
      document: prescription,
      emiratesIdFront: EmiratesIDFont,
      emiratesIdBack: EmiratesIDBack,
      message: message,
      deliveryTo:
        typeof address === "string"
          ? address
          : address?.fullAddress || address?.streetAddress,
      addressId: typeof address === "string" ? address : address?._id,
      havePrescription: true,
    };

    let formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value instanceof File) {
        formData.append(key, value);
      } else {
        formData.append(key, value as string);
      }
    });
    setLoader(true);
    const { res, err } = await httpRequest<{ data: IAddressData | null }>({
      path: "/customer-prescription/add",
      method: "put",
      params: formData,
      header: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (res) {
      toast.success("Prescription uploaded successfully");
      navigate("/");
    } else {
      toast.error(err?.message || "Something went wrong");
    }
    setLoader(false);
  };

  return (
    <div className="w-full bg-banner-white-image py-4">
      <div className="view-area-width">
        <div className="w-full flex flex-col gap-4 max-w-[850px] lg:max-w-[80%] mx-auto">
          <BoxWrapper title="Select Delivery Address">
            <DileveryAddressTitle hasOwnModal className="font-size-14px" />
          </BoxWrapper>
          <BoxWrapper title="Upload Prescription">
            <ImageUpload
              onImageChange={(image) => {
                setPrescription(image);
              }}
              allowedExtensions={[".jpg", ".jpeg", ".png", ".pdf"]}
              allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
              image={prescription}
              newUiFrontend={true}
              extraClasses="w-full h-[300px] border-1 border-[#00A297]"
              labelId="prescription-image-upload"
            />
          </BoxWrapper>
          <BoxWrapper title="Patient's ID Details">
            <div className="w-full flex gap-8">
              <div className="w-[50%]">
                <p className="font-Poppins-Medium text-[#2F2F31] font-size-16px">
                  CNIC (Front)
                  {/* CNIC ID (Front) */}
                </p>
                <ImageUpload
                  onImageChange={(image) => {
                    setEmiratesIDFront(image);
                  }}
                  image={EmiratesIDFont}
                  newUiFrontend={true}
                  extraClasses="w-full h-[300px] text-[#878787] border-1 border-[#00A297] mt-2 "
                  labelId="emirates-id-front-image-upload"
                />
              </div>
              <div className="w-[50%]">
                <p className="font-Poppins-Medium text-[#2F2F31] font-size-16px">
                  CNIC (Back)
                  {/* CNIC ID (Back) */}
                </p>
                <ImageUpload
                  onImageChange={(image) => {
                    setEmiratesIDBack(image);
                  }}
                  image={EmiratesIDBack}
                  newUiFrontend={true}
                  extraClasses="w-full h-[300px] border-1 border-[#00A297] mt-2 "
                  labelId="emirates-id-back-image-upload"
                />
              </div>
            </div>
            <p className="font-Poppins-Medium text-[#2F2F31] font-size-16px mt-4">
              Message
            </p>
            <SimpleInput
              value={message}
              labelText="Type your message here"
              extraStyle={{
                border: "1px solid #00A297",
                marginTop: "10px",
                minHeight: "140px",
              }}
              type="textArea"
              onChange={(value) => setMessage(value)}
              id="message-input"
              isLimit={300}
              maxLength={300}
            />
          </BoxWrapper>
          {/* <div className="w-full relative py-4"> */}
          <div className="w-full flex justify-end mb-4">
            <GradientBtn
              onPress={handleSubmit}
              ButtonText="Proceed"
              btnExtraStyle={{
                width: "fit-content",
              }}
              loader={loader}
              fontfamilyBtn="font-Lexend-SemiBold"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ValidPrescription;
